<script setup lang="ts">
import type { PropType } from 'vue'

defineProps({
  type: {
    type: String as PropType<'interator_simple'>,
    default: 'interator_simple',
  },
  hideDetails: {
    type: Boolean,
    default: true,
  },
  label: {
    type: String,
    default: '',
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const value = defineModel<string>({ default: '' })
</script>

<template>
  <VTextField
    v-model="value"
    :hide-details="hideDetails"
    :label="label"
    :loading="loading"
    readonly
  />
</template>
